import React, { PropsWithoutRef, ReactPropTypes } from "react";
import {
  IconCalendar,
  IconDeviceDesktop,
  IconIcons,
  IconId,
  IconSpeakerphone,
  IconSocial
} from "@tabler/icons-react";
import { RequestType } from "../types/request.types";

interface RequestIconMapping {
  business_card_request: React.FC;
  design_project_request: React.FC;
  event_request: React.FC;
  marketing_campaign_request: React.FC;
  web_update_request: React.FC;
  social_media_post_request: React.FC;
}

const requestIcons: RequestIconMapping = {
  'design_project_request': IconIcons,
  'web_update_request': IconDeviceDesktop,
  'social_media_post_request': IconSocial,
  'event_request': IconCalendar,
  'marketing_campaign_request': IconSpeakerphone,
  'business_card_request': IconId,
};

interface RequestIconProps {
  requestType: RequestType;
}

const RequestIcon = <T extends RequestIconProps>(props: T) => {
  const { requestType, ...iconProps } = props;
  const Icon = requestIcons[requestType];

  return (
    <>
      <Icon {...iconProps} />
    </>
  );
}

export default RequestIcon;
